/**
 * Google Drive Types
 *
 * TypeScript interfaces for Google Drive integration
 */

/**
 * OAuth tokens returned from Google authentication
 */
export interface GoogleDriveTokens {
  accessToken: string;
  refreshToken?: string;
  expiresAt?: number;
  scope: string;
}

/**
 * Google Drive file metadata from the Drive API
 */
export interface GoogleDriveFile {
  id: string;
  name: string;
  mimeType: string;
  size?: string;
  modifiedTime?: string;
  webViewLink?: string;
  thumbnailLink?: string;
  parents?: string[];
}

/**
 * Google Drive folder for navigation
 */
export interface GoogleDriveFolder {
  id: string;
  name: string;
  path?: string;
}

/**
 * Connection state for Google Drive integration
 */
export type GoogleDriveConnectionState =
  | 'disconnected'
  | 'connecting'
  | 'connected'
  | 'error';
